import React from 'react'
import { Box, Modal } from '@mui/material';
import { format } from 'date-fns';
import CancelPresentationIconButton from '../../../common/components/Buttons/CancelPresentationIconButton';
import { useEMRGeneralContext } from '../newGeneralEmr/EMRContextGeneral';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from '@mui/material';
import { Typography } from '@mui/material';
export default function PastComplaint(props) {
  const { patientHistoryData, setPatientHistoryData } = props;

  return (
    <div>
      <Modal
        open={props.openPastComplaint}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "30%",
            height: "60%",
            overflowY: "scroll",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            // borderRadius:5,
          }}
        >
          <div className=''>
            <div className="text-base flex justify-between items-center ">
              <div className="font-semibold">Past Complaints</div>
              <div className="">
                <CancelPresentationIconButton
                  onClick={() => {
                    props.setOpenPastComplaint(false);
                  }}
                />
              </div>
            </div>
            <div className='gap-2 flex flex-wrap mt-3 '>
              {
              patientHistoryData?.historyDepartmentWise?.complaints?.length > 0 ? (
                <>
                {patientHistoryData?.historyDepartmentWise?.complaints.map((row)=>(
                  <div className='grid grid-cols-1'>
                  <h1 className='font-semibold text-[16px] text-gray-500 ml-2'>{format(new Date(row.date),"dd MMM yyyy")}</h1>
                 <span key={row.id} className='border border-blue-500 text-blue-700 rounded-xl text-center p-[5px]'>{row.complaint}</span>
                 </div> ))}

                </>
              ):("")
            }
              {/* {     patientHistoryData?.historyDepartmentWise?.complaints?.length > 0 && (  
            <ol class="relative border-s border-teal-300 dark:border-teal-300">
              {patientHistoryData?.historyDepartmentWise?.complaints.map((row)=>(
              <li class="mb-10 ms-4">
                <div class="absolute w-3 h-3 bg-teal-400 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">{format(new Date(row.date),"dd MMM yyyy")}</time>
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white">{row.complaint}</h3>
             
              </li>
                ))}
              
            </ol>
         )} */}
              {/* {patientHistoryData?.historyDepartmentWise?.complaints?.length > 0 && (
                <ol className="relative border-s-2 border-teal-300 dark:border-teal-300">
                  {[...new Set(patientHistoryData.historyDepartmentWise.complaints.map((c) => c.date))].map((date) => {
                    const formattedDate = new Date(date);
                    const day = format(formattedDate, "dd");
                    const month = format(formattedDate, "MMM");
                    const year = format(formattedDate, "yyyy");
                    return (
                      <li key={date} className=" ms-4 w-[300px]  border border-gray-300 bg-white shadow-md rounded-md px-3 mt-2">
                        <div className='block'>

                          <div className="absolute w-4 h-4 font-semibold bg-teal-400 rounded-full block mt-1.5 -left-2 border border-white text-center p-[2px] dark:border-gray-900 dark:bg-gray-700 text-white">  <div className="absolute text-sm flex font-normal text-gray-500 -top-5 right-0 dark:text-gray-400">
                          
                          </div>

                          </div>
                        </div>
                        <time class="mb-1 text-sm  leading-none text-blue-400  font-semibold dark:text-gray-500">{format(formattedDate, "dd MMM yyyy")}</time>
                        {patientHistoryData.historyDepartmentWise.complaints
                          .filter((complaint) => complaint.date === date)
                          .map((complaint, index) => (
                            <>

                              <div key={index} className="font-normal text-sm text-gray-900 dark:text-white">
                                {complaint.complaint}
                              </div>
                            </>
                          ))}
                      </li>
                    );
                  })}
                </ol>
              )} */}


            </div>
          </div>

        </Box>
      </Modal>
    </div>
  )
}
